'use strict';

/**
 * Variadic helper function
 *
 * @param args
 * @returns {Array}
 */

module.exports = function variadic(args) {
  if (Array.isArray(args[0])) {
    return args[0];
  }

  return args;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/helpers/variadic.js
// module id = TbcB
// module chunks = 0